module.exports = "pegasus/assets/blocks/column-lp15-basic.png";